import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { E as inputCheckboxInvalid, F as inputCheckboxCheckedFocused, G as inputCheckboxFocused, H as inputCheckboxChecked, I as inputCheckbox, l as label } from './parts.js';
import { F as FormControlHelpText } from './form-control-help-text3.js';
import { F as FormControlErrorText } from './form-control-error-text.js';
import './details.js';

const CheckboxInput = /*@__PURE__*/ proxyCustomElement(class CheckboxInput extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.formControlInput = createEvent(this, "formControlInput", 7);
        this.formControlBlur = createEvent(this, "formControlBlur", 7);
        this.isFocused = false;
        this.handleFormControlInput = (event) => {
            event.preventDefault();
            const target = event.target;
            const name = target.getAttribute('name');
            this.inputHandler(name, target.checked);
            this.formControlInput.emit({ name, value: target.value });
        };
        this.updateInput = (newValue) => {
            this.checkboxElement.checked = newValue;
        };
    }
    get part() {
        if (this.errorText) {
            return inputCheckboxInvalid;
        }
        if (this.isFocused && this.checked) {
            return inputCheckboxCheckedFocused;
        }
        if (this.isFocused) {
            return inputCheckboxFocused;
        }
        if (this.checked) {
            return inputCheckboxChecked;
        }
        return inputCheckbox;
    }
    render() {
        return (h(Host, { key: '51ebd9d5b1eba8b7eba8f9c89551b9cbc754d706' }, h("div", { key: '5a8c60a4f259adbd6d78223c538d39ed3865a799', class: 'form-group d-flex flex-column' }, h("div", { key: '36f5b7b0ee0371990a5243c0cf0209a04085c66d', class: "form-check" }, h("input", { key: 'b85a3a2e09cea7b5ac9462ffa2b425524218d590', ref: el => (this.checkboxElement = el), type: "checkbox", id: this.name, name: this.name, onFocus: () => this.isFocused = true, onBlur: () => {
                this.isFocused = false;
                this.formControlBlur.emit();
            }, onInput: this.handleFormControlInput, part: this.part, class: this.errorText ? 'form-check-input is-invalid' : 'form-check-input', disabled: this.disabled, checked: this.checked }), h("label", { key: '4493c4c522a46ae995b2fdeeaab15487e273bf09', class: "form-check-label", htmlFor: this.name, part: label }, this.label)), h(FormControlHelpText, { key: '5fbddaeefb1e1d1ed5e088cf64edfb18f51cda72', helpText: this.helpText, name: this.name }), h(FormControlErrorText, { key: '7d2f579ef1ba9042096d6c29b8570d5259a27bc0', errorText: this.errorText, name: this.name }))));
    }
}, [0, "form-control-checkbox", {
        "label": [1],
        "name": [8],
        "helpText": [1, "help-text"],
        "errorText": [1, "error-text"],
        "checked": [4],
        "inputHandler": [16, "input-handler"],
        "disabled": [4],
        "isFocused": [32]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["form-control-checkbox"];
    components.forEach(tagName => { switch (tagName) {
        case "form-control-checkbox":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CheckboxInput);
            }
            break;
    } });
}
defineCustomElement();

export { CheckboxInput as C, defineCustomElement as d };
